import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import Login from '../pages/Login';
import ForgetPassword from '../pages/ForgetPassword';

import About from '../pages/About';
//import ParentDashboard from '../pages/ParentDashboard';
import AdminDashboard from '../pages/Admins/Dashboard';
import ChildDashboard from '../pages/Admins/ChildDashboard';
import Missions from '../pages/Admins/Missions';
import ParentDashboard from '../pages/Parents/Dashboard';
import NotFound from '../pages/NotFound';
// import Missions from '../pages/Missions';
import Physical from '../pages/Physical';
import SleepHabits from '../pages/SleepHabits';

import { useAuth } from '../hooks/AuthContext';
import AddMission from '../pages/Admins/Missions/AddMission';

const Routes = () => {

  const { type } = useAuth();
  // eslint-disable-next-line
  if (type == 1) {
    return (
      <Switch>
        <Route path="/newDash" exact component={ParentDashboard} />
        <Route path="/about" exact component={About} />
        <Route path="/physical-activity" exact component={Physical} />
        <Route path="/sleep-habits" exact component={SleepHabits} />
        <Route path="/" component={ParentDashboard} />
      </Switch>
    )
  }
  // eslint-disable-next-line
  if (type == 2) {
    return (
      <Switch>
        <Route path="/dashboard" exact component={AdminDashboard} />
        <Route path="/childDashboard" exact component={ChildDashboard} />
        <Route path="/missions" exact component={Missions} />
        <Route path="/missions/add-missions" exact component={AddMission} />
        <Route path="/physical-activity" exact component={Physical} />
        <Route path="/sleep-habits" exact component={SleepHabits} />
        <Route path="/about" exact component={About} />
        <Route path="/" component={AdminDashboard} />
      </Switch>
    )
  }
  // eslint-disable-next-line
  if (type == undefined || 1 || 2) {
    return (
      <Switch>
        <Route path="/" exact component={Login} />
        <Route path="/forget-password" exact component={ForgetPassword} />
        <Route path="/about" exact component={About} />
        <Route path="/" component={Login} />
      </Switch>
    )
  }
}

export default Routes;